module.exports = __webpack_public_path__ + "img/SDG-03-EN.772f73aa.png";